// extracted by mini-css-extract-plugin
module.exports = {"button":"CommunicationStyles_button__3jIop","title":"CommunicationStyles_title__ov1OQ"};